<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/IPcbvO/images/cover.jpg?1685327486164" alt="This image is the cover for the book The Havener Sisters"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Havener Sisters
      </h1>
      <p class="bookDescription body article font2">
        <p>China, Persia, and India Havener are triplets raised on the seas aboard their father’s ship, the Empress. Upon his death, the sisters take up residence in a large house along the shore in Castine, Maine. After eight years of life as land-lubbers, the sisters are suddenly faced with a change in economic circumstances that propels them into</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ardeana Hamlin
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Islandport Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?41116306